import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { apiService } from '../../constants/ApiService';

const AINavigationSearch = () => {
  const navigate = useNavigate();

  const [query, setQuery] = useState('');
  const [loading, setLoading] = useState(false);
  const [lastResult, setLastResult] = useState(null);

  const handleSearch = async () => {
    const searchText = query.trim();

    if (!searchText) {
      toast.warning('Please enter search text.');
      return;
    }

    try {
      setLoading(true);
      setLastResult(null);

      const response = await apiService.post('api/Ai/SearchNavigation', {
        query: searchText,
      });

      console.log('RAW RESPONSE:', response);

      // IMPORTANT:
      // If apiService returns axios response => response.data
      // If apiService returns direct object => response
      const result = response?.data || response;

      console.log('RESULT:', result);

      const isSuccess =
        result?.isSuccess === true || result?.IsSuccess === true;

      // IMPORTANT:
      // Actual navigation data is inside result.data
      const navData = result?.data || result?.Data;

      console.log('NAV DATA:', navData);

      const found = navData?.found === true || navData?.Found === true;

      const route = navData?.route || navData?.Route;
      const title = navData?.title || navData?.Title;
      const message = navData?.message || navData?.Message;

      setLastResult(navData);

      if (isSuccess && found && route) {
        toast.success(message || `Opening ${title}`);
        navigate(route);
      } else {
        toast.info(message || 'No matching page found.');
      }
    } catch (error) {
      console.error('AI Navigation Search Error:', error);
      toast.error('Navigation search failed.');
    } finally {
      setLoading(false);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleSearch();
    }
  };

  return (
    <div className='card shadow-sm border-0'>
      <div className='card-body'>
        <h5 className='card-title mb-3'>AI Navigation Search</h5>

        <div className='input-group'>
          <input
            type='text'
            className='form-control'
            placeholder='Example: how to add lead'
            value={query}
            onChange={(e) => setQuery(e.target.value)}
            onKeyDown={handleKeyDown}
            disabled={loading}
          />

          <button
            type='button'
            className='btn btn-primary'
            onClick={handleSearch}
            disabled={loading}
          >
            {loading ? 'Searching...' : 'Search'}
          </button>
        </div>

        {lastResult && (
          <div className='mt-3 small text-muted'>
            <div>
              <strong>Result:</strong>{' '}
              {lastResult.title || lastResult.Title || 'No title'}
            </div>
            <div>
              <strong>Route:</strong>{' '}
              {lastResult.route || lastResult.Route || '-'}
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AINavigationSearch;
